import gene20FormModel from "./gene20FormModel";
const {
  formField: {
    firstName,
    lastName,
    email,
    password,
    industryCatergory,
    experienceLevel,
    dateOfBirth,
    gender,
    phoneContact1,
    location,
    whatsappContact,
  },
} = gene20FormModel;

export default {
  [whatsappContact.name]: "",
  [location.name]: "",
  [firstName.name]: "",
  [lastName.name]: "",
  [email.name]: "",
  [password.name]: "",
  [industryCatergory.name]: "",
  [experienceLevel.name]: "",
  [dateOfBirth.name]: "",
  [gender.name]: "",
  [phoneContact1.name]: "",
};
